import cx from 'classnames'
import { useRouter } from 'next/router'
import React, { useEffect, useRef } from 'react'
import { useHeader } from '../../contexts'
import { EditMe } from '../../sharedComponents'
import { IPageSEO, ITimeLineElement } from '../../types'
import { parseHTML } from '../ContentParser/ContentParser'
import { TimeBullet } from './TimeBullet'
import {
  Anchor,
  InnerTimeWrapper,
  ItemContent,
  ItemTitle,
  MainItemWrapper,
  StyledAdWrap,
  TimeLineItem,
  TimeWrapper,
} from './TimeLine.styles'
import { TimeLineBox } from '../Ads'

type TimeLineSubItemProps = {
  index: number
  adIndex: number
  isLast: boolean
  orderClassName: string
  SEO: IPageSEO
  el: [string, ITimeLineElement]
  data: {
    data: ITimeLineElement
    id: string
    key: string | number
  }
  color: string
}

export const TimeLineSubItem = ({
  orderClassName,
  adIndex,
  isLast,
  index,
  el,
  data: { data },
  color = '#b80000',
}: TimeLineSubItemProps) => {
  const anchorRef = useRef<HTMLDivElement>()
  const { headerHeight } = useHeader()
  const date = new Date(data.createdOn)

  const router = useRouter()
  useEffect(() => {
    const hash = router.asPath.split('#').pop()
    if (anchorRef.current && hash === data.id) {
      setTimeout(function () {
        if (anchorRef.current) {
          anchorRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start',
          })
        }
      }, 1000)
    }
  }, [anchorRef, data.id, router])

  return (
    <React.Fragment key={'ti' + index}>
      <MainItemWrapper>
        <TimeWrapper className={cx('rightSide')}>
          <InnerTimeWrapper
            className={cx(orderClassName)}
            theme={{ isLast: isLast, innerTimeWrapperColor: color }}
          >
            <TimeBullet
              color={color}
              order={orderClassName}
              date={data.createdOn}
            ></TimeBullet>
          </InnerTimeWrapper>
        </TimeWrapper>
        <TimeLineItem theme={orderClassName}>
          <Anchor
            key={data.id}
            headerHeight={headerHeight}
            ref={anchorRef as React.RefObject<HTMLDivElement>}
            id={data.id}
          />
          <EditMe grid_id={el[1].id} anchorId={data.id}>
            <>
              <ItemTitle>{data.post_title}</ItemTitle>
              <ItemContent>
                {parseHTML({
                  html: data.post_content,
                  adMidArticle: false,
                  keyPrefix: 'tlparser',
                  bbProps: {
                    anchorId: data.id,
                    index,
                    isTimeLine: true,
                    isBigBrother: router.asPath.includes('the-big-brother'),
                    title: data.post_title,
                    time: date.toTimeString().slice(0, 5),
                  },
                })}
              </ItemContent>
            </>
          </EditMe>
        </TimeLineItem>
      </MainItemWrapper>
      {adIndex == 1 && (
        <StyledAdWrap theme={{ color: color }}>
          <div className={'line'} />
          <TimeLineBox pos={1} />
        </StyledAdWrap>
      )}
    </React.Fragment>
  )
}
